const roles = {
  admin: "admin",
  inProgramme: "in_programme",
  preProgramme: "pre_programme",
  postProgramme: "post_programme",
  disabled: "disabled",
};

export default roles;
